import md5 from 'md5'

import { queueAnalyticsEvent,SeoEvent } from 'lib/gtm'
import {
  CustomerTypes,
  getDatalayerPhoneNumber,
  isCustomerAdult} from 'modules/customer'

export const userLoginSeo = ({
  user,
  method
}: {
  user?: CustomerTypes
  method: string
}) => {
  const eventData = {
    event: SeoEvent.LOGIN, //constant
    type: 'other events', //constant
    user_id: user?.code || undefined, //User ID from crm if logged in, if not we return undefined
    user_adult: isCustomerAdult(user?.dateOfBirth), //1 if user have more than 18 years, 0 - if no, if no value we return undefined
    hashed_email: user?.email ? md5(user?.email) : undefined, //customer email in md5 - if logged in, if not we return undefined
    method: method, //login method
    user_data: {
      email: user?.email || undefined,
      phone_number: user?.phoneNumber
        ? getDatalayerPhoneNumber(user?.phoneNumber)
        : undefined,
      address: {
        first_name: user?.firstName || undefined,
        last_name: user?.lastName || undefined,
        country: 'PL'
      }
    } //first party data which we can use for google ads enhanced conversions - set undefined if no value
  }

  queueAnalyticsEvent(eventData)
}

export const gtmSignupEvent = (user: CustomerTypes) => {
  const email = md5(user.email).toString()

  const dataLayerPayload = {
    event: SeoEvent.SIGN_UP, //constant
    type: 'other events', //constant
    user_id: user.code, //User ID from crm if logged in, if not we return undefined
    user_adult: undefined, //1 if user have more than 18 years, 0 - if no, if no value we return undefined
    hashed_email: email, //customer email in md5 - if logged in, if not we return undefined
    method: 'email', //login method
    user_data: {
      email: user.email,
      address: {
        first_name: user.firstName,
        last_name: user.lastName,
        street: undefined,
        city: undefined,
        region: undefined,
        postal_code: undefined,
        country: undefined
      }
    }
  }

  queueAnalyticsEvent(dataLayerPayload)
}
